module.exports = __webpack_public_path__ + "static/img/FR.18f9ae1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/FR.svg
// module id = Q2tC
// module chunks = 66